import React from "react";
import AnimatedNumber from "./AnimatedNumber";

export default function StatCard({ icon: Icon, label, value, format, sub, accent = "#A78BFA", action, testId }) {
  return (
    <div
      data-testid={testId}
      className="border border-white/10 bg-[#111113] rounded-xl p-5 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#A78BFA]/30"
    >
      <Icon className="w-5 h-5 mb-2" style={{ color: accent }} />
      <AnimatedNumber value={value} format={format} className="text-2xl font-display font-bold text-white" />
      <p className="text-xs text-zinc-500 mt-0.5">{label}</p>
      {sub && <p className="text-[10px] text-zinc-600 mt-1 leading-snug">{sub}</p>}
      {action}
    </div>
  );
}
